import { api } from "shared/api";
import { API_ROUTES, baseURL } from "shared/api/consts";

export const EditProfileApi = async (dto: any) => {
  const { data } = await api.post(API_ROUTES.ACCOUNT_UPDATE, dto, {
    baseURL,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return data;
};
